import { render, staticRenderFns } from "./RecDataReport.vue?vue&type=template&id=8d475d0e&"
import script from "./RecDataReport.vue?vue&type=script&lang=js&"
export * from "./RecDataReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports